const state = reactive({
  button: [],
})

export function useButton() {
  const storyblokApi = useStoryblokApi()
  const { locale } = useI18n()

  async function fetchButton() {
    const { data } = await storyblokApi.get('cdn/stories/', {
      version: 'published',
      starts_with: 'components/button/',
      per_page: 100,
      is_startpage: false,
      language: locale.value,
    })

    state.button = data.stories
  }

  const formattedButton = computed(() =>
    state.button.map(({ uuid }) => ({
      uuid,
    })),
  )

  return {
    ...toRefs(state),
    fetchButton,
    formattedButton,
  }
}
